import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Table, Tooltip } from 'antd';
import { CloseSquareOutlined } from '@ant-design/icons';
import { getDashboard } from 'store/dashboard';
import { getExamList } from 'store/exam';
import { getLicense } from 'store/license';

import { nowEpoch } from 'utils/commonFunctions';
import { Option } from 'utils/commonValues';
import Loading from 'components/common/Loading';
import DashboardLicense from 'components/branch/dashboard/DashboardLicense';
import DashboardChart from 'components/branch/dashboard/DashboardChart';
import ModalTemplate from 'components/common/ModalTemplate';
import './Dashboard.scss';

// import sendImage from 'img/exam/list_send.png';
// import readImage from 'img/exam/list_read.png';
// import downImage from 'img/exam/list_down.png';
// import infectionImage from 'img/exam/list_infection.png';

export const authLevel = 1;
export default function Dashboard() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [examList, setExamList] = useState([]);

  // 라이센스
  const license = useSelector((state: any) => {
    return {
      data: state.license.data.success,
    };
  });
  // 대시보드
  const dashboard = useSelector((state: any) => {
    return {
      data: state.dashboard.data,
      buildLicenseData: state.dashboard.buildLicenseData,
      statisticsData: state.dashboard.statisticsData,
      infectionTarget: state.dashboard.infectionTarget,
      infectionTag: state.dashboard.infectionTag,
      notice: state.dashboard.notice,
    };
  });
  // 훈련 실시 결과
  const startExamResult = useSelector((state: any) => state.startExam.result.success);

  useEffect(() => {
    onGetDashboard();
    onGetLicense();
    setTimeout(() => {
      onGetExamList();
    }, 1000);
  }, [startExamResult]);

  // 대시보드 정보 조회
  const onGetDashboard = async () => {
    try {
      setLoading(true);
      const response: any = await dispatch(getDashboard());
      if (response?.data?.notice?.noticeTitle) {
        setOpenModal(true);
      }
    } catch (error) {
      console.log('Dashboard onGetDashboard', error);
    }
  };

  // 훈련 리스트 조회
  const onGetExamList = async () => {
    try {
      const params = {
        examNo: 'all',
        subTab: 'pi',
        examFilter: { examIng: 1 },
        sort: [{ field: 'examNo', order: 'DESC' }],
        offset: 0,
        limit: 5,
        refresh: true,
      };
      const response: any = await dispatch(getExamList(params));
      if (!response?.data?.error) {
        setExamList(response?.data?.list);
      }

      setLoading(false);
      // if (!response?.data?.error) {
      // const examArray: any = [];
      // response.data.list?.forEach((exam: any) => {
      //   // 진행중인 훈련 최대 5개까지 출력
      //   if (
      //     new Date(exam.examStartDate) <= new Date() &&
      //     new Date() <= new Date(exam.examEndDate) &&
      //     examArray.length < 5
      //   ) {
      //     examArray.push(exam);
      //   }
      // });
      // setExamList(examArray);
      // }
    } catch (error) {
      console.log('Dashboard onGetExamList', error);
    }
  };

  // 라이센스 조회
  const onGetLicense = async () => {
    try {
      await dispatch(getLicense());
    } catch (error) {
      console.log('Dashboard onGetLicense', error);
    }
  };

  // 유지보수 라이선스
  let buildLicense = null;
  // 기간(+영구) 라이선스
  const periodLicense: any = [];
  // 횟수 라이선스
  const timesLicense: any = [];

  if (Object.keys(dashboard.buildLicenseData).length > 0) {
    // 사용중인 유지보수 라이선스
    if (nowEpoch() < dashboard.buildLicenseData.licenseEndDate) {
      buildLicense = dashboard.buildLicenseData;
    }
  }

  license.data?.forEach((data: any) => {
    if (data && data.issueEpoch) {
      // 사용중인 기간, 횟수 라이선스
      const { licenseType, startEpoch, endEpoch, examUsedCount, examLimitCount } = data;
      if (
        (licenseType === 1 || licenseType === 2) &&
        nowEpoch() >= startEpoch &&
        nowEpoch() <= endEpoch
      ) {
        // 기간 라이선스
        periodLicense.push(data);
      } else if (licenseType === 4 && examUsedCount !== examLimitCount) {
        // 횟수 라이선스
        timesLicense.push(data);
      }
    }
  });

  const infectionTargetComp = [];
  const infectionTagComp = [];
  for (let i = 0; i < 5; i += 1) {
    infectionTargetComp.push(
      <div className="content-row" key={dashboard.infectionTarget[i] || i}>
        <div className="content-text ellipsis">
          <i>{i + 1}</i>
          {dashboard.infectionTarget[i]?.targetName || '-'}
        </div>
        <div className="content-value">
          {dashboard.infectionTarget[i]?.infectionCount
            ? `${formatMessage({ id: 'Infection_1', defaultMessage: '감염' })} ${
                dashboard.infectionTarget[i].infectionCount
              }${formatMessage({ id: 'License_13', defaultMessage: '회' })}`
            : '-'}
        </div>
      </div>,
    );

    infectionTagComp.push(
      <div className="content-row" key={dashboard.infectionTag[i] || i}>
        <div className="content-text ellipsis">
          <i>{i + 1}</i>
          {dashboard.infectionTag[i]?.tagName || '-'}
        </div>
        <div className="content-value">
          {dashboard.infectionTag[i]?.infectionCount
            ? `${formatMessage({ id: 'Infection_1', defaultMessage: '감염' })} ${
                dashboard.infectionTag[i].infectionCount
              }${formatMessage({ id: 'License_13', defaultMessage: '회' })}`
            : '-'}
        </div>
      </div>,
    );
  }

  return (
    <div className="dashboard-page">
      <Loading loading={loading} />
      <div className="dashboard">
        {/* left */}
        <div className="left-area">
          <div className="left">
            <div className="board-row">
              <div className="board top">
                <div className="content-title">
                  {formatMessage({ id: 'Exam_77', defaultMessage: '월별 훈련 수' })}
                </div>
                <DashboardChart
                  type="bar"
                  data={dashboard.data}
                  target="examCount"
                  message={formatMessage({ id: 'StartExam_21', defaultMessage: '개' })}
                  color="#14ae96"
                />
              </div>
              <div className="board top">
                <div className="content-title">
                  {formatMessage({ id: 'Exam_78', defaultMessage: '월별 훈련 대상 수' })}
                </div>
                <DashboardChart
                  type="bar"
                  data={dashboard.data}
                  target="targetCount"
                  message={formatMessage({ id: 'StartExam_35', defaultMessage: '명' })}
                  color="#14ae96"
                />
              </div>
              <div className="board-exam">
                <div className="statistics-row">
                  <div className="statistics-item all">
                    <div className="statistics-title">
                      {formatMessage({ id: 'Exam_5', defaultMessage: '전체 훈련' })}
                    </div>
                    <div className="number">
                      {dashboard.statisticsData?.examCount}
                      <span>{formatMessage({ id: 'StartExam_21', defaultMessage: '개' })}</span>
                    </div>
                  </div>
                  <div className="statistics-item reserve">
                    <div className="statistics-title">
                      {formatMessage({ id: 'Exam_9', defaultMessage: '예약 훈련' })}
                    </div>
                    <div className="number">
                      {dashboard.statisticsData?.reserveExamCount}
                      <span>{formatMessage({ id: 'StartExam_21', defaultMessage: '개' })}</span>
                    </div>
                  </div>
                </div>
                <div className="statistics-row">
                  <div className="statistics-item ing">
                    <div className="statistics-title">
                      {formatMessage({ id: 'Exam_8', defaultMessage: '진행 중인 훈련' })}
                    </div>
                    <div className="number">
                      {dashboard.statisticsData?.progressExamCount}
                      <span>{formatMessage({ id: 'StartExam_21', defaultMessage: '개' })}</span>
                    </div>
                  </div>
                  <div className="statistics-item end">
                    <div className="statistics-title">
                      {formatMessage({ id: 'Exam_76', defaultMessage: '종료된 훈련' })}
                    </div>
                    <div className="number">
                      {dashboard.statisticsData?.endExamCount}
                      <span>{formatMessage({ id: 'StartExam_21', defaultMessage: '개' })}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="board-row">
              <div className="board middle">
                <div className="content-title">
                  {formatMessage({ id: 'Exam_37', defaultMessage: '훈련 결과' })}
                </div>
                <DashboardChart
                  type="line"
                  data={dashboard.data}
                  target="examResult"
                  message={{
                    send: formatMessage({ id: 'Send_1', defaultMessage: '발송' }),
                    read: formatMessage({ id: 'Read_1', defaultMessage: '열람' }),
                    download: formatMessage({
                      id: 'Download_5',
                      defaultMessage: '파일 다운/피싱 접속',
                    }),
                    infection: formatMessage({
                      id: 'Infection_25',
                      defaultMessage: 'PC 감염 / 정보 유출',
                    }),
                  }}
                  color={{
                    send: '#14ae96',
                    read: '#f69c2e',
                    download: '#711bd1',
                    infection: '#dc3030',
                  }}
                />
              </div>
              {dashboard.statisticsData && (
                <div className="board-target">
                  <div className="target-row">
                    <div className="target-item">
                      <DashboardChart
                        type="circle"
                        target="send"
                        data={dashboard.statisticsData}
                        message={formatMessage({ id: 'Send_17', defaultMessage: '발송률' })}
                        color={{ start: '#14ae96', end: '#058f88' }}
                        icon="/img/exam/list_send.png"
                      />
                    </div>
                    <div className="target-item">
                      <DashboardChart
                        type="circle"
                        target="read"
                        data={dashboard.statisticsData}
                        message={formatMessage({ id: 'Read_4', defaultMessage: '열람률' })}
                        color={{ start: '#f69c2e', end: '#ff8715' }}
                        icon="/img/exam/list_read.png"
                      />
                    </div>
                  </div>
                  <div className="target-row">
                    <div className="target-item">
                      <DashboardChart
                        type="circle"
                        target="download"
                        data={dashboard.statisticsData}
                        message={formatMessage({
                          id: 'Download_12',
                          defaultMessage: '다운/접속률',
                        })}
                        color={{ start: '#711bd1', end: '#4506a1' }}
                        icon="/img/exam/list_down.png"
                      />
                    </div>
                    <div className="target-item">
                      <DashboardChart
                        type="circle"
                        target="infection"
                        data={dashboard.statisticsData}
                        message={formatMessage({
                          id: 'Infection_45',
                          defaultMessage: '감염/유출률',
                        })}
                        color={{ start: '#dc3030', end: '#bd0e0e' }}
                        icon="/img/exam/list_infection.png"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="board-row">
              <div className="board bottom">
                <div className="content-title">
                  {formatMessage({ id: 'Exam_8', defaultMessage: '진행 중인 훈련' })}
                </div>
                {examList.length > 0 ? (
                  <div className="exam-list-table">
                    <div className="table-header">
                      <Row>
                        <Col
                          className="gutter-row exam-name"
                          title={formatMessage({ id: 'Exam_1', defaultMessage: '훈련명' })}
                        >
                          {formatMessage({ id: 'Exam_1', defaultMessage: '훈련명' })}
                        </Col>
                        <Col
                          className="gutter-row exam-period"
                          title={formatMessage({ id: 'Period_3', defaultMessage: '훈련기간' })}
                        >
                          {formatMessage({ id: 'Period_3', defaultMessage: '훈련기간' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Target_2', defaultMessage: '대상' })}
                        >
                          {formatMessage({ id: 'Target_2', defaultMessage: '대상' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Send_1', defaultMessage: '발송' })}
                        >
                          {formatMessage({ id: 'Send_1', defaultMessage: '발송' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Read_1', defaultMessage: '열람' })}
                        >
                          {formatMessage({ id: 'Read_1', defaultMessage: '열람' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={`${formatMessage({
                            id: 'Download_1',
                            defaultMessage: '다운',
                          })}/${formatMessage({ id: 'Download_11', defaultMessage: '접속' })}`}
                        >
                          {`${formatMessage({
                            id: 'Download_1',
                            defaultMessage: '다운',
                          })}/${formatMessage({
                            id: 'Download_11',
                            defaultMessage: '접속',
                          })}`}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={`${formatMessage({
                            id: 'Infection_1',
                            defaultMessage: '감염',
                          })}/${formatMessage({ id: 'Infection_44', defaultMessage: '유출' })}`}
                        >
                          {`${formatMessage({
                            id: 'Infection_1',
                            defaultMessage: '감염',
                          })}/${formatMessage({
                            id: 'Infection_44',
                            defaultMessage: '유출',
                          })}`}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Cure_1', defaultMessage: '치료' })}
                        >
                          {formatMessage({ id: 'Cure_1', defaultMessage: '치료' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Infection_3', defaultMessage: '감염 PC' })}
                        >
                          {formatMessage({ id: 'Infection_3', defaultMessage: '감염 PC' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Target_3', defaultMessage: '신고한 대상자' })}
                        >
                          {formatMessage({ id: 'Target_3', defaultMessage: '신고한 대상자' })}
                        </Col>
                        <Col
                          className="gutter-row"
                          title={formatMessage({ id: 'Edu_2', defaultMessage: '연결된 교육' })}
                        >
                          {formatMessage({ id: 'Edu_2', defaultMessage: '연결된 교육' })}
                        </Col>
                      </Row>
                    </div>
                    {examList.length > 0 &&
                      examList.map((data: any) => {
                        return (
                          <Row key={data.examNo}>
                            <Col className="gutter-row exam-name">
                              <Tooltip
                                overlayClassName="black-tooltip full"
                                placement="bottomLeft"
                                title={data.examName}
                              >
                                <div className="ellipsis">{data.examName}</div>
                              </Tooltip>
                            </Col>
                            <Col className="gutter-row exam-period">
                              <Tooltip
                                overlayClassName="black-tooltip full"
                                placement="bottom"
                                title={`${data.examStartDate.split(' ')[0]} ~ ${
                                  data.examEndDate.split(' ')[0]
                                }`}
                              >
                                <div className="ellipsis">{`${data.examStartDate.split(' ')[0]} ~ ${
                                  data.examEndDate.split(' ')[0]
                                }`}</div>
                              </Tooltip>
                            </Col>
                            <Col className="gutter-row">{data.target}</Col>
                            <Col className="gutter-row">{data.send}</Col>
                            <Col className="gutter-row">{data.read}</Col>
                            <Col className="gutter-row">{data.download}</Col>
                            <Col className="gutter-row">{data.infection}</Col>
                            <Col className="gutter-row">{data.cure}</Col>
                            <Col className="gutter-row">
                              <Tooltip
                                overlayClassName="black-tooltip full"
                                placement="bottom"
                                title={
                                  data.infectionPc
                                    ? `${data.infectionPc}${formatMessage({
                                        id: 'Infection_29',
                                        defaultMessage: '대',
                                      })}`
                                    : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })
                                }
                              >
                                {data.infectionPc
                                  ? `${data.infectionPc}${formatMessage({
                                      id: 'Infection_29',
                                      defaultMessage: '대',
                                    })}`
                                  : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })}
                              </Tooltip>
                            </Col>
                            <Col className="gutter-row">
                              <Tooltip
                                overlayClassName="black-tooltip full"
                                placement="bottom"
                                title={
                                  data.declare
                                    ? `${data.declare}${formatMessage({
                                        id: 'StartExam_35',
                                        defaultMessage: '명',
                                      })}`
                                    : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })
                                }
                              >
                                {data.declare
                                  ? `${data.declare}${formatMessage({
                                      id: 'StartExam_35',
                                      defaultMessage: '명',
                                    })}`
                                  : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })}
                              </Tooltip>
                            </Col>
                            <Col className="gutter-row">
                              <Tooltip
                                overlayClassName="black-tooltip full"
                                placement="bottom"
                                title={
                                  data.edu
                                    ? `${data.edu}${formatMessage({
                                        id: 'Exam_26',
                                        defaultMessage: '개',
                                      })}`
                                    : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })
                                }
                              >
                                {data.edu
                                  ? `${data.edu}${formatMessage({
                                      id: 'Exam_26',
                                      defaultMessage: '개',
                                    })}`
                                  : formatMessage({ id: 'Infection_28', defaultMessage: '없음' })}
                              </Tooltip>
                            </Col>
                          </Row>
                        );
                      })}
                  </div>
                ) : (
                  <div className="exam-no-data">
                    {formatMessage({ id: 'Exam_79', defaultMessage: '진행 중인 훈련이 없습니다.' })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* right */}
        <div className="right-area">
          <div className="right">
            {/* 기간 라이선스(영구: 1, 기간: 2) */}
            <div className="board">
              <DashboardLicense
                licenseData={periodLicense[0]}
                licenseType={periodLicense[0]?.licenseType || 2}
              />
            </div>

            {/* 횟수(4), 유지보수(3) 라이선스 */}
            <div className="board">
              <DashboardLicense
                licenseData={
                  Option.isSaas === 0 && buildLicense && Object.keys(buildLicense).length > 0
                    ? buildLicense
                    : timesLicense[0]
                }
                licenseType={
                  Option.isSaas === 0 && buildLicense && Object.keys(buildLicense).length > 0
                    ? 3
                    : 4
                }
              />
            </div>

            {/* 위험 대상자 TOP5 */}
            <div className="board top5">
              <div className="content-title">
                {formatMessage({ id: 'Target_53', defaultMessage: '위험 대상자 TOP5' })}
              </div>
              <div className="content">{infectionTargetComp}</div>
            </div>

            {/* 위험 태그 TOP5 */}
            <div className="board top5">
              <div className="content-title">
                {formatMessage({ id: 'Tag_54', defaultMessage: '위험 태그 TOP5' })}
              </div>
              <div className="content">{infectionTagComp}</div>
            </div>
          </div>
        </div>
      </div>

      {/* 공지 모달 */}
      <ModalTemplate
        className="notice-modal modal-665"
        isCloseBlack
        visible={openModal && localStorage.getItem('notice') === 'true'}
        onCancel={() => setOpenModal(false)}
        centered
        footer={
          <div
            onClick={() => {
              localStorage.setItem('notice', 'false');
              setOpenModal(false);
            }}
            aria-hidden="true"
          >
            <CloseSquareOutlined />
            {formatMessage({ id: 'Header_12', defaultMessage: '다음 로그인 시까지 보지 않음' })}
          </div>
        }
      >
        <div className="notice-title">{dashboard.notice.noticeTitle}</div>
        <pre className="notice-content">{`${dashboard.notice.noticeContent}`}</pre>
      </ModalTemplate>
    </div>
  );
}
